import { UndergroundStorageTankInput } from "generated-graphql/graphql";
import { omit } from "lodash-es";

/** The tank form seeds from the loaded tank; drop what the server owns. */
export function transform(
  input: UndergroundStorageTankInput & { previouslyReported?: boolean | null }
): UndergroundStorageTankInput {
  return omit(input, "previouslyReported");
}
